export const financialOverviewColumnKeys = (accountType) =>
  accountType === "individual"
    ? ["accountName", "document", "balance"]
    : ["accountName", "balance"];
